import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Paper, Tooltip, Typography } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import UnoButton from "../../utils/UnoButton";
import { unoTheme } from "../../../assets/styles/unoTheme";
import MySwitch from '../../utils/MySwitch';

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

//API
import { UserAPI } from "../../../API/user";

//MyInputs
import MyTextField from "../../utils/MyTextField";

import CircularProgress from '@material-ui/core/CircularProgress';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import _ from 'lodash';

import MyDatePicker from '../../utils/MyDatePicker'

import { isValidEmail, isValidCpf, justNumbers, applyMaskPhone, getConsultingId, isValidCnpj } from "../../utils/utils";

import ConfirmActionRightContent from './ConfirmActionRightContent'
import MySelect from "../../utils/MySelect";
import { AccreditationProcessAPI } from "../../../API/accreditationProcess";
import MyInfo from "../../utils/MyInfo";
import moment from "moment";


const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(5)
    },

    main: {
        height: 'calc(100% - 128px)',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        textAlign: 'left',
        overflowY: 'scroll',
        paddingBottom: theme.spacing(3),

        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }

    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    detailRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

    },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    warning: {
        color: unoTheme.warningColor
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    selectable: {
        '& input': {

            cursor: 'pointer',
            color: unoTheme.mainColor,
        }
    }


}));

export const AccreditationProcessCategories = [
    "Gestor", "Administrador", "Custodiante", "Instituição bancária", "Distribuidor", "Assesoria", "Corretora"
];

export default function NewAccreditationProcess(props) {

    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();

    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const dispatch = useDispatch();

    //const clientOn = useSelector(state => state.clientOn)

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);

    const [confirmingAction, setConfirmingAction] = useState(false);

    //form    
    const [submitted, setSubmitted] = useState(false);

    const [processNumber, setProcessNumber] = useState("");
    const [termNumber, setTermNumber] = useState("");
    const [instituition, setInstituition] = useState("");
    const [cnpj, setCnpj] = useState("");
    // const [category, setCategory] = useState(0);
    const [categoriesIds, setCategoriesIds] = useState([]);
    const [validity, setValidity] = useState(new Date());

    async function doSaveAccreditationProcess(event) {

        event.preventDefault();
        setSubmitted(true);

        setOpenBackdrop(true);

        const accreditationProcess = {
            id: content.update ? content.data.id : null,
            client_id: clientOn.client.id,
            user_id: currentUser.user.id,
            process_number: processNumber,
            term_number: termNumber,
            instituition: instituition,
            cnpj: cnpj,
            categories_ids: categoriesIds,
            validity_date: validity,
        }

        if (accreditationProcess.client_id
            && accreditationProcess.user_id
            && accreditationProcess.process_number
            && accreditationProcess.term_number
            && accreditationProcess.instituition
            && isValidCnpj(accreditationProcess.cnpj)
            //&& accreditationProcess.category_id !== null
            && accreditationProcess.categories_ids?.length
            && accreditationProcess.validity_date
        ) {

            accreditationProcess.categories_ids = JSON.stringify(accreditationProcess.categories_ids);
            const response = await AccreditationProcessAPI.save(accreditationProcess);
            if (response.success) {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: `Processo ${content.update ? 'atualizado' : 'cadastrado'} com sucesso`

                }));

                dispatch(allActions.rightContentActions.update())

            } else {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: `Erro ao ${content.update ? 'atualizar' : 'cadastrar'} o processo: ` + response.body.message

                }));
            }

        }


        setOpenBackdrop(false);
    }

    function initForm(process) {

        setProcessNumber(process.process_number || "");
        setTermNumber(process.term_number || "");
        setInstituition(process.instituition || "");
        setCnpj(process.cnpj || "");
        // setCategory(process.category_id || 0);
        setCategoriesIds(process.categories_ids ? JSON.parse(process.categories_ids) : []);
        setValidity(process.validity_date ? new Date(process.validity_date) : new Date());
    }

    async function doDeleteAccreditationProcess() {

        setOpenBackdrop(true)

        //content contem data que contem a conta que foi aberta no componente lateral
        const response = await AccreditationProcessAPI.delete(content.data.id);

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Processo excluído com sucesso!'
            }))

        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: `Erro ao excluir processo: ` + response.body.message
            }))
        }

        setOpenBackdrop(false)
        dispatch(allActions.rightContentActions.update());

    }

    //deleção da conta
    function handleCancel() {
        setConfirmingAction(false);
    }

    function handleConfirm() {
        doDeleteAccreditationProcess();
    }

    useEffect(() => {

        //Caso seja a edição de um manager
        if (content) {

            if (content && content.update) {
                initForm(content.data);
            }
        }


    }, []);

    return (
        <div className={classes.root}>

            {
                !confirmingAction ?

                    <>
                        <div className={classes.header}>
                            <IconButton
                                className={!content.update ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <ArrowBackIcon />
                            </IconButton>


                            <div>
                                <Typography
                                    variant={'h6'}
                                    align={'center'}>

                                    {content.update ? "Editar Processo de Credenciamento" : "Cadastrar Processo de Credenciamento"}

                                </Typography>

                                <Typography
                                    variant={'body1'}
                                    align={'center'}
                                    style={{ color: unoTheme.defaultTextColor }}>

                                    {content?.data?.processNumber ? `Processo Nº: ${content.data.processNumber}` : ''}

                                </Typography>

                            </div>


                            <IconButton className={content.update ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <CloseIcon />
                            </IconButton>

                        </div>


                        <div className={classes.main}>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={6}>
                                    <MyTextField required
                                        outerlabel="Num. do Processo"
                                        size={'small'}
                                        validator={processNumber == "" && submitted ? true : undefined}
                                        variant="outlined"
                                        onChange={(value) => setProcessNumber(value)}
                                        helperText={"Insira o número do processo"}
                                        placeholder={'Insira o número do processo'}
                                        value={processNumber} />
                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>
                                    <MyTextField required
                                        outerlabel="Num. do Termo/Atestado"
                                        size={'small'}
                                        validator={termNumber == "" && submitted ? true : undefined}
                                        variant="outlined"
                                        onChange={(value) => setTermNumber(value)}
                                        helperText={"Insira o número do termo/atestado"}
                                        placeholder={'Insira o número do termo/atestado'}
                                        value={termNumber} />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <MyTextField
                                        value={instituition}
                                        variant="outlined"
                                        size={'small'}
                                        onChange={(value) => setInstituition(value)}
                                        validator={!instituition && submitted ? true : undefined}
                                        helperText={"Insira um nome de instituição válido"}
                                        placeholder={'Insira o nome da instituição'}
                                        outerlabel="Instituição" />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <MyTextField
                                        value={cnpj}
                                        onChange={(value) => setCnpj(value)}
                                        size={'small'}
                                        variant="outlined"
                                        validator={!isValidCnpj(cnpj) && submitted ? true : undefined}
                                        helperText={"Insira um CNPJ válido"}
                                        mask={['cnpj']}
                                        placeholder={'Insira o CNPJ'}
                                        outerlabel="CNPJ" />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>

                                    <MySelect
                                        multiple
                                        outerlabel="Categoria"
                                        valuesMultiple={categoriesIds}
                                        onChange={(values) => {
                                            setCategoriesIds([...values]);
                                        }}
                                        validator={categoriesIds.length === 0 && submitted ? true : undefined}
                                        helperText={"Insira pelo menos uma categoria válida"}
                                        optionsMultiple={AccreditationProcessCategories.map((el, index) => ({
                                            value: index,
                                            label: el,
                                        }))}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={6} md={6}>

                                    <MyDatePicker
                                        margin="dense"
                                        id="date-picker-dialog-process-validity"
                                        outerlabel="Data do credenciamento"
                                        format="DD/MM/YYYY"
                                        value={validity}
                                        onChange={(value) => setValidity(value)} />

                                </Grid>

                                {
                                    validity &&
                                    <Grid item xs={12} sm={6} md={6}>

                                        <MyInfo outerlabel="Validade do credenciamento"
                                            label={moment.utc(validity).add(2, 'year').subtract(1, 'day').format("DD/MM/YYYY")}
                                            colorInfo={moment.utc(validity).add(2, 'year').subtract(1, 'day').isBefore(moment.utc(new Date())) ? unoTheme.redMoney : unoTheme.greenMoney} />

                                    </Grid>
                                }

                            </Grid>

                            <br />
                            <br />
                            <div className={classes.bottom}>

                                <div className={'bottomButtons'}>

                                    <UnoButton
                                        className={
                                            !content.update ? classes.hiddenIcon : null}
                                        onClick={() => setConfirmingAction(true)}
                                        type='errorClean'>
                                        {"Excluir processo"}
                                    </UnoButton>

                                    <UnoButton
                                        onClick={(e) => doSaveAccreditationProcess(e)}
                                        type={content.update ? 'success' : 'primary'}>
                                        {content.update ? "Atualizar Processo" : "Salvar Processo"}
                                    </UnoButton>
                                </div>

                            </div>

                        </div>
                    </>

                    :

                    <ConfirmActionRightContent
                        message={`Tem certeza que quer excluir 
                        o process ${content && content.data ? content.data.process_number : ''}?`}
                        handleCancel={handleCancel}
                        handleConfirm={handleConfirm}
                    />

            }




            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }


        </div>
    );
}



